import React from 'react';
import { Component } from '@poa/core';
import PaymentStaff from '../../staff/payment-staff';

import {
  BANK_NAME,
  WALLET_NAME,
  WEB_MONEY_NAME,
  WESTERN_UNION_NAME,
  CRYPTO_NAME
} from '../../../constants/type-payment';

class AccountRequisites extends React.Component {
  store;
  actions; // injected by Poa
  t;

  componentDidMount() {
    // console.log('this.props.state.model', this.props.state.model);
  }

  handleOnChange = (data) => {

    // console.log('data', data);
    // this.store.accounts.originalModel = data
    this.store.accounts.model = data
  }

  render() {

    let { originalModel, isEdit } = this.store.accounts;

    return (

      <div className='general_info__content'>
        {
          isEdit ?
            <div className="tab__inner" style={{ display: 'flex', justifyContent: 'center' }}>
              <div className="main-form" style={{ minWidth: "400px", maxWidth: "400px" }}>
                <form
                  name="auth_form"
                  ref={node => (this.form = node)}
                >
                  <div className="form-payment">
                    <PaymentStaff
                      data={originalModel}
                      userId={originalModel.id}
                      disabledButton={true}
                      onChangeData={this.handleOnChange}
                    />
                  </div>
                </form>
              </div>
            </div>
            :
            <div className="tab__inner" style={{ display: 'flex', justifyContent: 'center' }}>
              <div className="main-form" style={{ minWidth: "400px", maxWidth: "400px" }}>
                <form
                  name="auth_form"
                  ref={node => (this.form = node)}
                >
                  <div className="form-payment">


                    <div className="disabled-inputs">
                      <h2>Страна</h2>
                      <input disabled value={originalModel.currentCountry.label || "-"} />

                      <h2>Тип перевода</h2>
                      <input disabled value={originalModel.currentTypePayment.label || "-"} />

                      {originalModel.currentTypePayment.label === BANK_NAME && (
                        <>
                          <h2>Банк</h2>
                          <input disabled value={originalModel.selectedOptionCard.label || "-"} />
                        </>
                      )}

                      {(originalModel.currentTypePayment.label !== CRYPTO_NAME) && (
                        <>
                          <h2>Данные получателя</h2>
                          <input disabled value={originalModel.recipientData.fullName || "-"} />


                          <h3>Номер телефона получателя</h3>
                          <input disabled value={originalModel.recipientData.phone || "-"} />

                        </>
                      )}

                      {originalModel.currentTypePayment.label === BANK_NAME && (
                        <>
                          <h3>Банковская карта</h3>
                          <input disabled value={originalModel.recipientData.cardNumber || "-"} />
                        </>)}


                      {((originalModel.currentTypePayment.label === WALLET_NAME) ||
                        (originalModel.currentTypePayment.label === WESTERN_UNION_NAME)) && (
                          <>
                            <h3>Город</h3>
                            <input disabled value={originalModel.recipientData.city || "-"} />
                          </>)}




                      {originalModel.currentTypePayment.label === WEB_MONEY_NAME && (
                        <>
                          <h3>Номер кошелька</h3>
                          <input disabled value={originalModel.recipientData.walletNumber || "-"} />
                        </>)}


                      {originalModel.currentTypePayment.label === CRYPTO_NAME && (
                        <>
                          <h3>Номер кошелька USDT TRC-20</h3>
                          <input disabled value={originalModel.recipientData.walletNumber || "-"} />
                        </>)}


                    </div>

                  </div>
                </form>
              </div>
            </div>
        }
      </div>

    );
  }
}

export default Component({ namespaces: ['account-requisites'] })(AccountRequisites);
